/**
 * Report Routes
 *
 * Titles/descriptions/breadcrumbs are auto-resolved by the i18n router
 * guard from each route's `name` — see `src/plugins/i18n/routeI18n.ts`.
 */

export default [
  {
    path: 'reports/general',
    name: 'reports.overview',
    component: () => import('../../pages/reports/OverallView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: 'debug/question/:questionID',
    name: 'debug.question',
    component: () => import('../../pages/debug/DebugQuestion.vue'),
    meta: { requiresAuth: true }
  }
]
